import { Component, OnInit, Inject, ViewChild} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { GastosService } from '../../../services/gastos.service';
import { HelpersService } from "../../../services/tools/helpers.service";
import { ErrorModalComponent } from '../../../components/tools/modals/error-modal/error-modal.component';
@Component({
  selector: 'app-delete-gasto',
  templateUrl: './delete-gasto.component.html',
  styleUrls: ['./delete-gasto.component.scss']
})
export class DeleteGastoComponent implements OnInit {

  @ViewChild(ErrorModalComponent) errorModal: ErrorModalComponent;

  public errors: any = {};
  
  constructor(
    private gastosService : GastosService,
    private helperService: HelpersService,
    public dialogRef: MatDialogRef<DeleteGastoComponent>,
    @Inject (MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {
    console.log(this.data);
  }

  public aceptar(){
    console.log("ID: ",this.data);
    this.gastosService.delete(this.data.idGasto)
      .subscribe(response => {
        const respuesta = response.json();
        if (respuesta.success) {
          this.helperService.notification('Gasto eliminado', 'Se ha borrado exitosamente', 'success');
          //Poner dentro del success response
          this.dialogRef.close({eliminar:true});
        }
      }, error => {
        if(error.status == 400) {
          this.showServicesErrors(error.json().content);
        }else{
          this.dialogRef.close({eliminar:false});
          this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
        }
        
        // se resuelven los errores 403 y 500
        this.helperService.httpGlobalError(error, false);
      });
    
  }

  public cerrar(){
    
    this.dialogRef.close({eliminar:false})
  }
  private showServicesErrors(errors:any[]){
    //Es posible que en algún momento se necesiten parsear los errores ya que las llaves del backend,
    //no correspondan con las llaves de los errores del front
    this.errors = errors;
  }
}



// WEBPACK FOOTER //
// ./src/app/gastos/dialogs/delete-gasto/delete-gasto.component.ts